import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useSidebar } from "../../context/sidebarContext";

export default function Drawer({
  open,
  onClose,
  title = "",
  children,
  width,
  position = "right", // Only used on md+ screens
}) {
  const { isTablet } = useSidebar();
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    if (open) document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [open, onClose]);

  if (typeof window === "undefined") return null;

  const desktopPosition =
    position === "right"
      ? open
        ? "lg:right-0 lg:translate-x-0"
        : "lg:right-0 lg:translate-x-full"
      : open
      ? "lg:left-0 lg:translate-x-0"
      : "lg:left-0 lg:-translate-x-full";

  const mobilePosition = open
    ? "max-lg:bottom-0 max-lg:translate-y-0"
    : "max-lg:bottom-0 max-lg:translate-y-full";

  return createPortal(
    <>
      {/* Backdrop */}
      {open && (
        <div
          className="fixed inset-0 z-[9998] bg-black/50 backdrop-blur-sm"
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      {/* lg:rounded-l-2xl max-lg:rounded-t-2xl */}

      <div
        className={`fixed z-[9999] bg-white overflow-y-auto transition-transform duration-300 transform shadow-lg
          w-full max-w-full lg:w-[75%] p-5
          max-lg:rounded-t-2xl
          lg:h-[100dvh] h-[80dvh]
          lg:top-0 
          ${mobilePosition} ${desktopPosition}
        `}
        style={{ maxWidth: isTablet ? "100%" : width ?? "75%" }}
        aria-labelledby="drawer-label"
        tabIndex={-1}
      >
        {children}
      </div>
    </>,
    document.body
  );
}
